import React from 'react';
import './SavedGamePopup.css';

// 盤面保存・読み込みのポップアップコンポーネント
const SavedGamePopup = ({ type, onClose, onSave, onLoad, onDelete, savedGames }) => {
  // 保存ポップアップを表示
  if (type === 'save') {
    return (
      <div className="popup-overlay">
        <div className="save-popup">
          <h3>盤面の保存</h3>
          <form onSubmit={(e) => {
            e.preventDefault();
            const name = e.target.saveName.value;
            const memo = e.target.memo.value;
            onSave(name, memo);
          }}>
            <div className="form-group">
              <label htmlFor="saveName">保存名:</label>
              <input 
                type="text" 
                id="saveName" 
                name="saveName" 
                defaultValue={`保存データ ${savedGames.length + 1}`} 
                required 
              />
            </div>
            <div className="form-group">
              <label htmlFor="memo">メモ (任意):</label>
              <textarea 
                id="memo" 
                name="memo" 
                placeholder="例: 行3列5に7を仅定した状態"
              ></textarea>
            </div>
            <div className="popup-buttons">
              <button type="button" onClick={onClose}>キャンセル</button>
              <button type="submit">保存する</button>
            </div>
          </form>
        </div>
      </div>
    );
  }
  
  // 読み込みポップアップを表示
  if (type === 'load') {
    return (
      <div className="popup-overlay">
        <div className="load-popup">
          <h3>保存した盤面の読み込み</h3>
          {savedGames.length > 0 ? (
            <div className="saved-games-list">
              {savedGames.map(game => (
                <div key={game.id} className="saved-game-item">
                  <div className="saved-game-info">
                    <h4>{game.name}</h4>
                    <p className="saved-date">{game.date}</p>
                    {game.memo && <p className="saved-memo">メモ: {game.memo}</p>}
                  </div>
                  <div className="saved-game-actions">
                    <button onClick={() => onLoad(game)}>読み込む</button>
                    <button 
                      className="delete-button"
                      onClick={() => onDelete(game.id)}
                    >
                      削除
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="no-saves">保存された盤面がありません</p>
          )}
          <div className="popup-buttons">
            <button onClick={onClose}>閉じる</button>
          </div>
        </div>
      </div>
    );
  }
  
  return null;
};

export default SavedGamePopup;